





















import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";

interface Payload {
  instName: string;
}

@Component({
  components: {
    "activity-label": ActivityLabel,
  }
})
export default class ActivityInstName extends Vue {
  @Getter("instName")
  getterInstName: any;
  @Action("changeInstName")
  changeInstName: any;
  @Getter("section")
  section: any;

  get instName(): string {
    return this.getterInstName;
  }

  set instName(val: string) {
    const payload: Payload = {
      instName: val
    };
    this.changeInstName(payload);
  }
}
